<lib-dialog
  [title]="titel || ('agb-dialog.text.agb' | translate)"
  [hideCloseButtonIcon]="true"
>
  <div body class="content" [innerHTML]="agb?.content"></div>
  <ng-container action>
    <lib-spacer></lib-spacer>
    <button mat-dialog-close mat-stroked-button>
      {{ 'agb-dialog.buttons.close' | translate }}
    </button>
    <lib-spacer></lib-spacer>
  </ng-container>
</lib-dialog>
